import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Column } from "primereact/column";
import { Tooltip } from 'primereact/tooltip';
import { FileUpload } from 'primereact/fileupload';
import CustomDropdown from "../../../../custom/customDropdown";
import handlePrintReceiverDispacher from './novaPrijemnicaOtpremnicaStampa';
import "primeicons/primeicons.css";
import ConfirmationModalPrijemnicaOtpremnica from "../../../../custom/ConfirmationModalPrijemnicaOtpremnica";
import ConfirmationModalArticles from "../../../../custom/ConfirmationModalArticles";
import UnosArtiklaKonfig from "../Artical/Unos_artikla_konfig";
import BarcodeScanner from './BarcodeScanner';
import GumaScanDijalog from './GumaScanDijalog';

const Nova_prijemnica = (props) => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const toast = useRef(null);
  const formRef = useRef(null);
  const formRefItems = useRef(null);
  const pdfRef = useRef(null);
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);
  const eskaliran = useSelector((state) => state.eskaliran);
  const userRole = useSelector((state) => state.user_role);
  
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formSubmittedItems, setFormSubmittedItems] = useState(false);

  const [confirmVisible, setConfirmVisible] = useState(false); 
  const [confirmVisibleArticles, setConfirmVisibleArticles] = useState(false); 
  

  const [klijentiOptions, setKlijentiOptions] = useState([]);
  const [magacinOptions, setMagacinOptions] = useState([]);
  
  const [jedinicaMereOptions, setJedinicaMereOptions] = useState([]);

  const [idReceiver, setIdReceiver] = useState(null);
  const [idItem, setIdItem] = useState(null);


  //Stavke
  const [nazivArtiklaOptions, setNazivArtiklaOptions] = useState([]);
  const [filterGuma, setFilterGuma] = useState(false);
  const [izabran, setIzabran] = useState(false);
  const [popuni, setPopuni] = useState(false);

  const [scannerVisible, setScannerVisible]       = useState(false);
  const [gumaDijalogVisible, setGumaDijalogVisible] = useState(false);
  const [scannedCode, setScannedCode]             = useState(null);
  const [gumaExisting, setGumaExisting]           = useState(null);
  const [persistMagacin, setPersistMagacin]       = useState(null);
  const [persistArtikla, setPersistArtikla]       = useState(null);
  const [persistDOT, setPersistDOT]               = useState('');
  const [scannerKey, setScannerKey]               = useState(0);

  const [allColumns, setAllColumns] = useState([]);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [selectedRowId , setSelectedRowId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  /* Broj stavki po strani bira korisnik; petnaest je polazno, jer toliko
     stane na uobičajen ekran bez skrolovanja same stranice. */
  const [redovaPoStrani, setRedovaPoStrani] = useState(15);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null; 
  
  const Add2HoursDate = (input) => {
    const base = new Date(input);
    const plus2h = new Date(base.getTime() + 2 * 60 * 60 * 1000);

    return plus2h
  }

  useEffect(() => {

      if(!props.changeArtical) {
            const {
        klijentiOptions,
        magacinOptions,
        nazivArtiklaOptions,
        jedinicaMereOptions
      } = props;
      
      setIdReceiver(props.idReceiver)
      setKlijentiOptions(klijentiOptions);
      setMagacinOptions(magacinOptions);
      setNazivArtiklaOptions(nazivArtiklaOptions)
      setJedinicaMereOptions(jedinicaMereOptions)
      }

      if (props.idReceiver) {
          popuniRedove(props.idReceiver)
          }
  }, [props]);

  useEffect(() => {
    return () => {
      setIdReceiver(null);
      props.setIdReceiverDispacher(null)
      resetData();
      resetDataItems();
    };
  }, []);
    
  
  // ====== DATA =====

  const [formData, setFormData] = useState({
    // header
    Broj: "", // readonly
    id_klijent: null, // *
    napomena: "",
    datum: null,
    Registracija: "", // readonly
    datumDokumentaDobavljaca: null
  });

  const [formDataItems, setFormDataItems] = useState({
    NazivArtikla: null,
    SifraStavke: null,
    JedinicaMere: null,
    kolicina: null,
    id_magacin: null,
    SerBroj: null,
    Kilometraza: null,
    DOT: null
  });


  const popuniStavkeItems = (apiData) => {
    const row = apiData.StavkeDB[0];
    if (row.SerBroj || row.Kilometraza) setFilterGuma(true);
    setFormDataItems({
      SifraStavke: row.NazivArtikla != null ? Number(row.NazivArtikla) : null,
      JedinicaMere: row.JedinicaMere != null ? Number(row.JedinicaMere) : null,
      kolicina: row.kolicina || null,
      id_magacin: row.id_magacin != null ? Number(row.id_magacin) : null,
      NazivArtikla: row.NazivArtikla != null ? Number(row.NazivArtikla) : null,
      SerBroj: row.SerBroj || null,
      Kilometraza: (!row.Kilometraza && '0') || null,
      DOT: row.DOT || null
    });
  }
      
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const handleStampaj = () => {
     if(idReceiver) {
              let requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth.token,
              },
              body: JSON.stringify({
                id: idReceiver,
                step: 'PRIJEMNICA'
              }),
            };
            
            fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/PrintReceiverDispacher", requestOptions)
              .then(handleErrors)
              .then((data) => {
    
                if(data){
                  handlePrintReceiverDispacher(data, 'PRIJEMNICA')
                } 
        
              })
              .catch((error) => {
                error.json().then((errorMessage) => {
                  toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: errorMessage.message,
                    life: 3000,
                  });
                  console.log(errorMessage);
                });
              });
            } else {
               toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Niste izabrali prijemnicu kako bi je štampali!",
                    life: 3000,
                  });
            }
  }

  const handleStorno = () => {
            confirmDialog({
                  message: `Jel ste sigurni da želite pasivizirati izabranu prijemnicu?`,
                  acceptLabel: "Da",
                  rejectLabel: "Ne",
                  icon: "pi pi-info-circle",
                  acceptClassName: "p-button-danger",
                  accept: acceptDelete,
                  reject: rejectDelete,
                });

  };

    const handleFakturisanje = () => {
        toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "U razvoju!",
        life: 3000,
      });
    // if (userRole.roleId == 1 || userRole.roleId == 3 || eskaliran?.eskaliran) {
    //         confirmDialog({
    //               message: `Jel ste sigurni da želite pasivizirati izabranu fakturu?`,
    //               acceptLabel: "Da",
    //               rejectLabel: "Ne",
    //               icon: "pi pi-info-circle",
    //               acceptClassName: "p-button-danger",
    //               accept: acceptDeleteInvoice,
    //               reject: rejectDeleteInvoice,
    //             });
  
    // } else {
    //   toast.current.show({
    //     severity: "warn",
    //     summary: "Upozorenje!",
    //     detail: "Nemate odgovarajuću ulogu profila za storaniranje prijemnice!",
    //     life: 3000,
    //   });
    // }
  };

 const acceptDelete = async () => {

    if (idReceiver) {
      let requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id: idReceiver
        }),
      };

      await fetch(
        process.env.REACT_APP_BACKEND_URL + "/warehouse/DeleteReceiver",
        requestOptions
      )
        .then(handleErrors)
        .then((data) => {

              if(data.message && data.message != 'Uspešno pasiviziranje prijemnice!'){
                  toast.current.show({
                  severity: "warn",
                  summary: data.message,
                  life: 3000,
                  });
                return
              }

          setIdReceiver(null);
          props.setIdReceiverDispatcher(null)
          setIdItem(null)
          setIzabran(null)
          setPopuni(null);
          resetData();
          resetDataItems();

          toast.current.show({
            severity: "success",
            summary: "Uspešno pasiviziranje podataka prijemnice!",
            life: 3000,
          });
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje!",
        detail: "Niste izabrali prijemnicu za brisanje!",
        life: 3000,
      });
    }
  };

  const rejectDelete = () => {
    console.log("Odbijeno brisanje prijemnice!");
  };

  const invalidControl = (data) => {
    if (!formSubmitted) return false;

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

    const invalidControlItems = (data) => {
    if (!formSubmittedItems) return false;

    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const addDays = (date, days) => {
    if (!date || days === null || days === undefined) return null;
    const d = date instanceof Date ? new Date(date) : new Date(date);
    if (isNaN(d.getTime())) return null;
    const n = Number(days);
    if (Number.isNaN(n)) return null;
    d.setDate(d.getDate() + n);
    return d;
  };

  const resetDataItems = () => {
    setFormDataItems({
      NazivArtikla: null,
      SifraStavke: '',
      JedinicaMere: null,
      kolicina: null,
      id_magacin: null,
      SerBroj: null,
      Kilometraza: null,
      DOT: null
    });
  }

  // ── Guma helpers ──────────────────────────────────────────────────────────────

  const revertGuma = async (serBroj) => {
    if (!serBroj) return;
    try {
      await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/RevertGumaPrijemnica', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({ serBroj }),
      }).then(handleErrors);
    } catch { /* silent — item was already removed */ }
  };

  const saveGumaItem = async (itemData) => {
    if (!idReceiver && !idItem) {
      toast.current.show({ severity: 'warn', summary: 'Nije moguće uneti stavku bez otvorene prijemnice!', life: 3000 });
      return;
    }
    try {
      const isUpdate = !!idItem;
      const url = isUpdate
        ? process.env.REACT_APP_BACKEND_URL + '/warehouse/UpdateReceiverItem'
        : process.env.REACT_APP_BACKEND_URL + '/warehouse/InsertReceiverItem';
      const body = isUpdate
        ? JSON.stringify({ id: idItem, formDataItems: itemData })
        : JSON.stringify({ id: idReceiver, formDataItems: itemData });

      const itemRes = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body,
      }).then(handleErrors);

      const msg = Array.isArray(itemRes) ? itemRes[0]?.message : itemRes?.message;
      if (msg && !msg.includes('Nema izmena')) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: msg, life: 3000 });
        return;
      }

      await fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/SaveGumaPrijemnica', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
        body: JSON.stringify({ serBroj: itemData.SerBroj, id_artikal: itemData.SifraStavke, kilometraza: itemData.Kilometraza ?? 0, dot: itemData.DOT ?? null, id_magacin: itemData.id_magacin ?? null }),
      }).then(handleErrors);

      toast.current.show({ severity: 'success', summary: 'Guma i stavka uspešno sačuvani!', life: 3000 });
      resetDataItems();
      setIdItem(null);
      setIzabran(false);
      setSelectedRowId(null);
      setFormSubmittedItems(false);
      setConfirmVisible(false);
      if (idReceiver || props.idReceiver) popuniRedove(idReceiver || props.idReceiver);
    } catch (err) {
      err?.json?.().then(e => toast.current.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 }));
    }
  };

  const handleScan = (code) => {
    setScannedCode(code);
    fetch(process.env.REACT_APP_BACKEND_URL + '/warehouse/GetGumaBySerBroj', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
      body: JSON.stringify({ serBroj: code }),
    })
      .then(handleErrors)
      .then(data => {
        const existing = Array.isArray(data) && data.length > 0 ? data[0] : null;
        if (existing && existing.id_magacin != null) {
          toast.current.show({ severity: 'warn', summary: 'Guma već primljena!', detail: `Guma ${code} je već primljena u magacin: ${existing.Lokacija || existing.id_magacin}.`, life: 5000 });
          setScannerKey(k => k + 1);
          return;
        }
        setGumaExisting(existing);
        setGumaDijalogVisible(true);
      })
      .catch(() => {
        setGumaExisting(null);
        setGumaDijalogVisible(true);
      });
  };

  const handleGumaDijalogConfirm = (itemData) => {
    setGumaDijalogVisible(false);
    setPersistMagacin(itemData.id_magacin ?? null);
    setPersistArtikla(itemData.NazivArtikla ?? null);
    setPersistDOT(itemData.DOT ?? '');
    setScannerKey(k => k + 1);
    saveGumaItem(itemData);
  };

  // ─────────────────────────────────────────────────────────────────────────────

  const resetData = () => {
    setFormData({
    Broj: "", // readonly
    id_klijent: null, // *
    napomena: "",
    datum: null,
    datumDokumentaDobavljaca: null,
    Registracija: ""
  });
  }

const handleNew = () => {
  resetData()
  resetDataItems()
  props.setIdReceiverDispacher(null)
  setIdReceiver(null)
  setIzabran(false)
  setTableData([])
}

  const handleChange = (e) => {
    const { name, value } = e.target || e;


if (name in formData) {

    if(name === 'Registracija'){
        setFormData((prev) => {
      const next = { ...prev, [name]: value.toUpperCase() };

      return next;
    });
    return
    }
    setFormData((prev) => {
      const next = { ...prev, [name]: value };

      return next;
    });
  }
  if (name in formDataItems) {
      if (name === "SerBroj") {
        const cleaned = value ? value.toString().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20) : null;
        setFormDataItems(prev => ({ ...prev, SerBroj: cleaned }));
        return;
      }
      if (name === "DOT") {
        const cleaned = value ? value.toString().replace(/[^0-9]/g, '').slice(0, 4) : null;
        setFormDataItems(prev => ({ ...prev, DOT: cleaned || null }));
        return;
      }
      if(name === "NazivArtikla") {
        let artikl = nazivArtiklaOptions.find(x => x.value === value)
        if(artikl) {
            setFormDataItems(prev => ({ ...prev, SifraStavke: value}));
            setFormDataItems(prev => ({ ...prev, JedinicaMere: artikl.JedinicaMere}));
        }
        if(!value){
            setFormDataItems(prev => ({ ...prev, SifraStavke: ''}));
            setFormDataItems(prev => ({ ...prev, JedinicaMere: null}));
        }
      }
      setFormDataItems(prev => ({ ...prev, [name]: value}));
  }

  };

  const handleFormSubmit = (e) => {
    e.preventDefault();


    setFormSubmitted(true);

    if (formRef.current && !formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati prijemnicu?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptSave,
    });
  };

  const popuniStavke = (apiData) => {

    setFormData({
        Broj: apiData[0].Broj || '',
        id_klijent: apiData[0].id_klijent || null,
        napomena: apiData[0].napomena || '',
        datum: apiData[0].datum ? new Date(apiData[0].datum) : null,
        datumDokumentaDobavljaca: apiData[0].datumDokumentaDobavljaca ? new Date(apiData[0].datumDokumentaDobavljaca) : null,
        Registracija: apiData[0].Registracija || null
    });
}

  const popuniRedove = async (id) => {
      if(id){
             setPopuni(true);
             setIzabran(true)
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/FillInReceiverData", requestOptions)
                            .then(handleErrors)
                            .then(async (data) => {

                              

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavke(data)
                                const parsedData = data[0].Stavke ? JSON.parse(data[0].Stavke) : [];

                                setTableData(parsedData);

                            if (parsedData.length > 0) {
                              const columns = Object.keys(parsedData[0])
                                .filter(key => !['ID'].includes(key))
                                .map(key => ({
                                label: key,
                                value: key
                                }));
                                setAllColumns(columns);
                                setSelectedColumns(columns.slice(0, 12).map(col => col.value));
                                }
                            
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                }
    }


  const acceptSave = async () => {

    try {

            const payload = {
                        ...formData,
                        datum: toUtcIso(formData.datum),
                        datumDokumentaDobavljaca: toUtcIso(formData.datumDokumentaDobavljaca)
                        };

                if(props.idReceiver || izabran){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: props.idReceiver ? props.idReceiver : idReceiver,
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/UpdateReceiver", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima prijemnice.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima prijemnice.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
  
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka prijemnice!",
                                life: 3000,
                                });
                                }
                                setFormSubmitted(false)
                                popuniRedove(idReceiver)
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else {
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/InsertReceiver", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setFormSubmitted(false)
                                resetData()
                                popuniRedove(data?.id)
                                setIdReceiver(data?.id)

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka prijemnice!",
                                life: 3000,
                                });
                              
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
            }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Greška",
        detail: "Neuspešno čuvanje.",
        life: 3000,
      });
    }
  };

  const openModalItems = () => {
    resetDataItems();
    setConfirmVisible(true);
  }

  const openModalArticles = () => {
    resetDataItems();
    setConfirmVisibleArticles(true);
    props.setChangeArtical(true);
  }

      const header = (
          <div className="export-buttons fakture-stavke-header">
              <Button type="button" style={{marginLeft:'1%'}} icon="pi pi-plus" severity="info" onClick={openModalItems} data-pr-tooltip="Nova stavka" />
                            <div style={{marginBottom: '5px', display:'flex', justifyContent:'right', maxWidth:'50%'}}>
                                              <input
                                                type="search"
                                                onInput={(e) => setGlobalFilter(e.target.value.replace(/\s+/g, ' ').trimStart())}
                                                placeholder={t('nova.phPretraga')}
                                                style={{width:'100%'}}
                                                className="p-inputtext p-component"
                                              /></div>
          </div>
      );

    const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };


    const chooseItem = async (rowData) => {    
      const id = getId(rowData);
        console.log(id)
  
      setSelectedRowId((prev) => {
        const next = String(prev) === String(id) ? null : String(id);
  
      return next;
    });
    
    setIdItem(id)

    }

    useEffect(()=> {

      if (idItem) {
          let requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + auth.token,
                },
                body: JSON.stringify({
                  id: idItem
                }),
              };
              
              fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/GetItemDataReceiver", requestOptions)
                .then(handleErrors)
                .then((data) => {

                                const preparedData = {
                                    StavkeDB: data
                                }

                                if(data.message){  
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                popuniStavkeItems(preparedData)

                    setConfirmVisible(true)
                })
                .catch((error) => {
                  error.json().then((errorMessage) => {
                    toast.current.show({
                      severity: "error",
                      summary: "Error",
                      detail: errorMessage.message,
                      life: 3000,
                    });
                    console.log(errorMessage);
                  });
                });
          }

    },[idItem])

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
  
      const selected = isSelected(rowData);
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
                tooltip="Izaberi stavku prijemnice za dalji rad"
                tooltipOptions={{ position: 'top' }}
              />
            
        </div>
      );
    };

  const saveItems = (x) => {

    confirmDialog({
      message: "Jel ste sigurni da želite sačuvati stavku prijemnice?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptSaveItems(x),
    });
  };

  const acceptSaveItems = async (x) => {

    try {

            if(idItem){
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem,
                                formDataItems
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/UpdateReceiverItem", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               if(data[0].message && data[0].message != 'Nema izmena u podacima stavke.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima stavke.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka stavke!",
                                life: 3000,
                                });
                                resetDataItems()
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                if(x){
                                  setConfirmVisible(false)
                                      if (props.idReceiver || idReceiver) {
                                            popuniRedove(props.idReceiver || idReceiver)
                                          }
                                }
                                setFormSubmittedItems(false)
                                }  
                               
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else {
                if(idReceiver) {
                  let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idReceiver,
                                formDataItems
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/InsertReceiverItem", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                if(x){
                                  setConfirmVisible(false)
                                  if (idReceiver) {
                                       popuniRedove(idReceiver)
                                      }
                                }
                                resetDataItems();
                                setFormSubmittedItems(false)

                               toast.current.show({
                                severity: "success",
                                summary: "Uspešan unos podataka stavke prijemnice!",
                                life: 3000,
                                });

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Nije mogući unos stavke, nije uspešno vezana za prijemnicu!",
                    life: 3000,
                  });
                }
                          
            }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Greška",
        detail: "Neuspešno čuvanje stavke.",
        life: 3000,
      });
    }
  };

  const handleFormRemoveItems = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite pasivizirati stavku prijemnice?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptRemoveItems,
    });
  }

  const acceptRemoveItems = async () => {
    const serBrojToRevert = formDataItems.SerBroj;

     if(idItem){
                          let requestOptions = {
                            method: "DELETE",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idItem
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/DeleteReceiverItem", requestOptions)
                            .then(handleErrors)
                            .then(async (data) => {

                               if(data.message){
                                    toast.current.show({
                                    severity: "warn",
                                    summary: "Upozorenje!",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }

                                resetDataItems()
                                setIdItem(null)
                                setIzabran(false)
                                setSelectedRowId(null)
                                setFormSubmittedItems(false)
                                if(props.idReceiver || idReceiver){
                                  await popuniRedove(props.idReceiver || idReceiver)
                                }
                                setConfirmVisible(false)
                                if (serBrojToRevert) revertGuma(serBrojToRevert);
                                toast.current.show({
                                    severity: "success",
                                    summary: "Uspešno!",
                                    detail: "Uspešno ste pasivizirali stavku prijemnice!",
                                    life: 3000,
                                    });
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
           
            } else{ 
                  toast.current.show({
                    severity: "warn",
                    summary: "Upozorenje!",
                    detail: "Nije obrisana stavka prijemnice, nije uspešno vezana za prijemnicu!",
                    life: 3000,
                  });
            }

  }

  const handleFormSubmitItems = (x) => {
    
                    setFormSubmittedItems(true)
                if (formRefItems.current && !formRefItems.current.checkValidity()) {
                    formRefItems.current.reportValidity(); // prikazuje native browser poruke
                    return;
                }
       saveItems(x)
     }

  return (
    <div className="p-fluid grid formUnosZap" style={{ maxWidth: "99%" }}>
      <Toast ref={toast} />
      <ConfirmDialog />

            <ConfirmationModalArticles                
                visible={confirmVisibleArticles}
                onHide={() => {setConfirmVisibleArticles(false); props.setChangeArtical(false);}}>
                <UnosArtiklaKonfig setChangeArtical={props.setChangeArtical}/>
            </ConfirmationModalArticles>
      
            <ConfirmationModalPrijemnicaOtpremnica
                visible={confirmVisible}
                onHide={() => {setConfirmVisible(false);setIdItem(null);setIzabran(false);setSelectedRowId(null);setFilterGuma(false);popuniRedove(props.idReceiver ? props.idReceiver : idReceiver)}}
                onConfirmContinue={() => {handleFormSubmitItems(false)}}
                onConfirmExit={() => {handleFormSubmitItems(true)}}
                onConfirmRemove={handleFormRemoveItems}
                idItem={idItem}
            >
              <form autoComplete="off" ref={formRefItems}  style={{ display:'flex', flexWrap: 'wrap', minWidth: '100%' }}>
                  <div className="col-12" style={{display:'flex', marginBottom:'0.5rem'}}>
                    <Button type="button" label={t('magacin.ostalo')} className=""
                      id={filterGuma === false ? 'activeButton' : undefined}
                      style={{fontSize: 'smaller', marginLeft:'0', marginTop:'0'}} onClick={() => { setFilterGuma(false); resetDataItems(); }} />
                    <Button type="button" label={t('magacin.pneumaticiGume')} className=""
                      id={filterGuma === true ? 'activeButton' : undefined}
                      style={{fontSize: 'smaller',marginLeft:'1rem', marginTop:'0'}} onClick={() => { setFilterGuma(true); resetDataItems(); }} />
                    {filterGuma === true && (
                      <Button type="button" icon="pi pi-qrcode" title="Skeniraj barkod gume"
                        severity="secondary"
                        style={{fontSize: 'smaller', marginLeft:'0.5rem', marginTop:'0'}}
                        onClick={() => { resetDataItems(); setPersistMagacin(null); setPersistArtikla(null); setPersistDOT(''); setScannerKey(k => k + 1); setScannerVisible(true); }} />
                    )}
                  </div>
                  <div className="col-6 md:col-6 stavkaPrijemFirst">
                    <label htmlFor="artikal">{t('magacin.nazivArtikla')}:</label>
                    <div style={{display:'flex'}}>
                        <CustomDropdown
                        id="NazivArtikla"
                        name="NazivArtikla"
                        optionLabel="label"
                        value={formDataItems.NazivArtikla}
                        options={filterGuma === null ? nazivArtiklaOptions : nazivArtiklaOptions.filter(a => !!a.Guma === filterGuma)}
                        onChange={handleChange}
                        placeholder={t('nova.phArtikal')}
                        style={{maxWidth:'90%'}}
                      />
                      <Button type="button" style={{maxWidth:'10%', display:'flex', justifyContent:'center', alignItems:'center'}} icon="pi pi-plus" severity="info" onClick={openModalArticles} data-pr-tooltip="Novi artikl" />
                    </div>
                  </div>
                  <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="SifraStavke">{t('magacin.sifraArtikla')}:</label>
                      <InputText
                        id="SifraStavke"
                        name="SifraStavke"
                        style={{minWidth: '100%'}}
                        disabled
                        value={formDataItems.SifraStavke}
                        onChange={handleChange}
                        type="number"
                      />
                  </div>

                  <div className="col-6 md:col-6 stavkaPrijem">
                    <label htmlFor="JedinicaMere">{t('nova.jedinicaMere')}:</label>
                    <CustomDropdown
                      id="JedinicaMere"
                      name="JedinicaMere"
                      optionLabel="label"
                      disabled
                      value={formDataItems.JedinicaMere}
                      options={jedinicaMereOptions}
                      onChange={handleChange}
                      placeholder={t('nova.phJedinicu')}
                    />
                  </div>

                  <div className="col-6 md:col-6 stavkaPrijem">
                    <label htmlFor="id_magacin">{t('nova.magacin')}:</label>
                    <CustomDropdown
                      id="id_magacin"
                      name="id_magacin"
                      optionLabel="label"
                      value={formDataItems.id_magacin}
                      options={magacinOptions}
                      required
                      invalid={invalidControlItems(formDataItems.id_magacin)}
                      onChange={handleChange}
                      placeholder={t('nova.phMagacin')}
                    />
                  </div>
                  <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="kolicina">{t('nova.kolicina')}:</label>
                    <InputNumber
                    id="kolicina"
                    name="kolicina"
                    required
                    style={{minWidth: '100%'}}
                    invalid={invalidControlItems(formDataItems.kolicina)}
                    value={formDataItems.kolicina}
                    onValueChange={handleChange}
                    min={1}
                    max={filterGuma ? 1 : undefined}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    />
                </div>
                {filterGuma === true && <>
                  <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="SerBroj">{t('magacin.serijskiBroj')}:</label>
                    <InputText
                      id="SerBroj"
                      name="SerBroj"
                      style={{minWidth: '100%'}}
                      value={formDataItems.SerBroj || ''}
                      onChange={handleChange}
                      maxLength={20}
                    />
                  </div>
                  <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="Kilometraza">{t('ture.kilometraza')}:</label>
                    <InputText
                      id="Kilometraza"
                      name="Kilometraza"
                      style={{minWidth: '100%'}}
                      type="number"
                      value={formDataItems.Kilometraza}
                      onChange={handleChange}
                      useGrouping={false}
                    />
                  </div>
                  <div className="col-6 md:col-3 stavkaPrijem">
                    <label htmlFor="DOT">{t('magacin.dot')}:</label>
                    <InputText
                      id="DOT"
                      name="DOT"
                      style={{minWidth: '100%'}}
                      value={formDataItems.DOT || ''}
                      onChange={handleChange}
                      maxLength={4}
                      placeholder={t('magacin.phPin')}
                    />
                  </div>
                </>}
            </form>
          </ConfirmationModalPrijemnicaOtpremnica>
      {/* OPCIJE TOOLBAR */}
      <div className="col-12 novaDinarskaIzlazneHeader">
        <Button label={t('magacin.nova')} type="button" style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}} onClick={handleNew} />
        <Button label={t('nova.stampa')} type="button" style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}} onClick={handleStampaj} />
        <Button
          label={t('nova.storno')}
          type="button"
          className="p-button-danger"
          style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
          onClick={handleStorno}
        />
        <Button
          label={t('magacin.unesiFakturu')}
          type="button"
          className="p-button-success"
          style={{padding:'0.2rem 0.5rem', maxHeight:'30px'}}
          onClick={handleFakturisanje}
        />
                          
      </div>
      <form
        autoComplete="off"
        ref={formRef}
        className="col-12 novaDinarskaIzlazneForm"
      >
          <div className="gridFakture">
            <div className="col-6 md:col-3">
              <label htmlFor="Broj">{t('nova.broj')}:</label>
              <InputText
                id="Broj"
                name="Broj"
                readOnly
                style={{ backgroundColor: "#efefef" }}
                value={formData.Broj}
              />
            </div>

            <div className="col-6 md:col-3">
              <label htmlFor="datum">{t('nova.datum')}:</label>
              <Calendar
                id="datum"
                name="datum"
                value={formData.datum}
                onChange={handleChange}
                required
                invalid={invalidControl(formData.datum)}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>

            <div className="col-6 md:col-6">
              <label htmlFor="id_klijent">{t('magacin.dobavljac')}:</label>
              <CustomDropdown
                id="id_klijent"
                name="id_klijent"
                optionLabel="label"
                required
                invalid={invalidControl(formData.id_klijent)}
                value={formData.id_klijent}
                options={klijentiOptions || []}
                onChange={handleChange}
                placeholder={t('magacin.phDobavljaca')}
              />
            </div>

            <div className="col-6 md:col-3">
              <label htmlFor="Registracija">{t('ture.registracija')}:</label>
              <InputText
                id="Registracija"
                name="Registracija"
                onChange={handleChange}
                required
                invalid={invalidControl(formData.Registracija)}
                value={formData.Registracija}
              />
            </div>

            <div className="col-12">
                <label htmlFor="napomena">{t('nova.napomena')}:</label>
                          <InputTextarea
                            id="napomena"
                            name="napomena"
                            value={formData.napomena}
                            onChange={handleChange}
                            rows={3}
                          />
            </div>
            <div className="col-6 md:col-3">
              <label htmlFor="datum">{t('magacin.datumDokDobavljaca')}:</label>
              <Calendar
                id="datumDokumentaDobavljaca"
                name="datumDokumentaDobavljaca"
                value={formData.datumDokumentaDobavljaca}
                onChange={handleChange}
                showIcon
                mask="99.99.9999"
                dateFormat="dd.mm.yy"
              />
            </div>
          </div>
      </form>
        {/* Visinu ograničava TELO tabele (scrollHeight), ne okvir — inače bi
            okvir odsekao paginator na nižem ekranu. `!important` u inline stilu
            React ionako ne primenjuje, pa margina ide kroz klasu. */}
        <div className="zaposleni_table_container tableItems stavke-okvir">
          <Toast ref={toast} />
              <Tooltip target=".export-buttons>button" position="bottom" />
              {/* Telo tabele raste sa ekranom, ali ne preko njega: na uobičajenom
                  ekranu stane petnaestak stavki, na nižem manje — i tada se skroluje
                  po stavkama, unutar tabele, a ne cela stranica. */}
              <DataTable
                paginator
                rows={redovaPoStrani}
                rowsPerPageOptions={[15, 30, 50, 100]}
                first={first}
                globalFilter={globalFilter}
                onPage={(e) => { setFirst(e.first); setRedovaPoStrani(e.rows); }}
                scrollable
                header={header}
                scrollHeight="clamp(200px, 52vh, 700px)"
                emptyMessage={t('common.noDataTable')}
                value={tableData || []}
                resizableColumns
                className="izlazneFaktureTable stavke-tabela"
                columnResizeMode="expand"
                rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
              >
                {selectedColumns.map((colKey) => {
                const colMeta = allColumns.find(col => col.value === colKey);
                return (
                  <Column
                    key={colKey}
                    field={colKey}
                    header={colMeta?.label || colKey}
                    sortable
                    body={(rowData) => {
                      if (isButtonColumn(colKey)) {
                        return previewBodyTemplate(rowData, colKey);
                      }
                      return rowData[colKey] ?? '-';
                    }}
                  />
                );
              })}
              </DataTable>
            </div>
      <div className="formUnosZap buttonUnosFakture">
        <button
          type="submit"
          onClick={handleFormSubmit}
          className="btn btn-success"
        >
          {props.idReceiver || idReceiver || izabran ? 'SAČUVAJ' : 'UNOS'}
        </button>
      </div>

      <BarcodeScanner
        key={scannerKey}
        visible={scannerVisible}
        onHide={() => { setScannerVisible(false); setGumaDijalogVisible(false); setPersistMagacin(null); setPersistArtikla(null); setPersistDOT(''); resetDataItems(); }}
        onScan={handleScan}
      />
      <GumaScanDijalog
        visible={gumaDijalogVisible}
        onHide={() => setGumaDijalogVisible(false)}
        onConfirm={handleGumaDijalogConfirm}
        serBroj={scannedCode}
        gumaData={gumaExisting}
        magacinOptions={magacinOptions}
        nazivArtiklaOptions={nazivArtiklaOptions}
        defaultMagacin={persistMagacin}
        defaultArtikla={persistArtikla}
        defaultDOT={persistDOT}
      />
    </div>
  );
};

export default Nova_prijemnica;
